module.exports = __webpack_public_path__ + "img/ico-caret-left.df7cef58.svg";